import { useMemo } from "react";
import { QueryParamUsage } from "../../../../../services/QueryParamService";

export type SortKey = "urlCount" | "count" | "name";
export type SortOrder = "asc" | "desc";

export type ParamView = {
  readonly filter: string;
  readonly sortKey: SortKey;
  readonly sortOrder: SortOrder;
};

const compareBy = (key: SortKey, a: QueryParamUsage, b: QueryParamUsage): number =>
  key === "name" ? a.paramName.localeCompare(b.paramName) : a[key] - b[key];

export const sortedFilteredParams = (params: readonly QueryParamUsage[], view: ParamView): QueryParamUsage[] => {
  const needle = view.filter.trim().toLowerCase();
  const direction = view.sortOrder === "asc" ? 1 : -1;
  return params
    .filter((param) => param.paramName.toLowerCase().includes(needle))
    .sort((a, b) => direction * compareBy(view.sortKey, a, b));
};

export const useSortedFilteredParams = (
  params: readonly QueryParamUsage[],
  view: ParamView
): QueryParamUsage[] => useMemo(() => sortedFilteredParams(params, view), [params, view]);
